import { ActiveWheelDto } from '../../../models/dtos/activeWheel.dto';
import axios from '../../axios';

export default async function getActiveWheelRequest(): Promise<ActiveWheelDto> {
  const response = await axios.get<ActiveWheelDto>(
    `${process.env.REACT_APP_BASE_URL}/users/wheel`
  );
  return response.data;
}
